import Container from "@mui/material/Container";
import { Outlet } from "react-router";

import ProgressSteps from "@/components/ProgressSteps/ProgressSteps";

const UpdateDataView = () => {
  return (
    <Container>
      <ProgressSteps />
      <Outlet />
    </Container>
  );
};

export default UpdateDataView;
